<template>
  <div class="admin-wrap swda-report">
    <div class="swda-report__header">
      <h3 class="swda-report__title">SWDA - PEI Annual Returns (AR)</h3>
      <div class="swda-report__form">
        <div class="swda-report__field">
          Year:
          <select v-model="year" class="swda-report__select">
            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
          </select>
        </div>
      </div>
      <a :href="exportCsvUrl" download class="swda-report__link">Download CSV</a>
      <a :href="exportPdfUrl" download class="swda-report__link">Download PDF</a>
    </div>

    <div class="swda-report__table-scroll">
      <table class="swda-report__table">
        <tr class="swda-report__row swda-report__row--head">
          <th v-for="col in columns" :key="col" class="swda-report__cell swda-report__cell--head">{{ col }}</th>
        </tr>

        <tr v-for="(row, i) in rows" :key="i" class="swda-report__row">
          <td v-for="col in columns" :key="col" class="swda-report__cell">{{ row[col] }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import DataSource from '@/data/datasource'
import { URLForEndpoint } from '@/data/requests'
import moment from 'moment'

export default {
  name: 'SwdaPeiAnnualReturns',
  data() {
    return {
      token: Cookies.get('authToken'),
      school: Cookies.get('schoolSession'),
      years: Array.from({ length: 4 }, (_, i) => moment().year() - i),
      year: moment().year(),
      rows: [],
    }
  },
  computed: {
    params() {
      return { school: this.school, year: this.year }
    },
    columns() {
      return this.rows.length ? Object.keys(this.rows[0]) : []
    },
    exportCsvUrl() {
      return URLForEndpoint('/controller/Api.asmx/SwdaPeiAnnualReturnsReport', {
        ...this.params,
        token: this.token,
        download: 'csv',
      })
    },
    exportPdfUrl() {
      return URLForEndpoint('/controller/Api.asmx/SwdaPeiAnnualReturnsReport', {
        ...this.params,
        token: this.token,
        download: 'pdf',
      })
    },
  },
  watch: {
    year() {
      this.update()
    },
  },
  methods: {
    api(data = {}) {
      const payload = { ...this.params, ...data }
      return DataSource.shared.callWebService('/controller/Api.asmx/SwdaPeiAnnualReturnsReport', payload, 'POST')
    },
    async update() {
      this.rows = []
      const data = await this.api()
      this.rows = Array.isArray(data) ? data : data?.Table || []
    },
  },
  async mounted() {
    await this.update()
  },
}
</script>

<style scoped>
.swda-report__header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
}

.swda-report__title {
  margin-right: auto;
  text-align: left;
}

.swda-report__form {
  display: flex;
  gap: 10px;
}

.swda-report__select {
  height: 30px;
  padding-left: 6px;
  padding-right: 6px;
}

.swda-report__table-scroll {
  width: 100%;
  max-width: 100%;
  max-height: 70vh;
  overflow: auto;
}

.swda-report__table {
  width: 100%;
  background: white;
  border-collapse: collapse;
}

.swda-report__cell {
  border: 1px solid #888;
  text-align: left;
  padding: 4px 6px;
  line-height: 1.2;
  white-space: pre-line;
  min-width: 150px;
}

.swda-report__cell--head {
  position: sticky;
  top: 0;
  z-index: 1;
  background: white;
  white-space: nowrap;
}
</style>
